// @ts-nocheck
import React from 'react';
import { compose } from '../../core';
import { withCreateContributor, withCreateOKR } from './objective-keyresult-operations';
import { withApollo } from '@apollo/client/react/hoc';
import { OKR_CHILD_LIST_QUERY, OKR_CHILD_SUBSCRIPTION } from '../graphql/ChildOKRList.gql';
import SubMileStoneTableView from '../components/SubMilestoneTableView';
import moment from 'moment-timezone';
import { kudos_permission } from 'Permissions/kudos.permission';
import { globalPermissionValidator } from 'modules/look';
const SubMileStoneTableContainer = props => {
  const {me,client,MilestoneDetail,userPermission}=props
  const [loading,setloading]= React.useState(true)
  const [allsubMilestone,setallsubMilestone]= React.useState()
  const [permission,setpermission]= React.useState()
  const dataRef = React.useRef()
  const m = React.useRef( true )

  React.useEffect( () => {
    return () => {
      m.current = false
    }
  }, [] )

  React.useEffect( () => {
    m.current = true

  }, [] )

  React.useEffect(()=>{
    if(userPermission?.length){
      let permission=globalPermissionValidator(kudos_permission,userPermission)
      setpermission(permission)
    }
    else{
      setpermission(null)
    }
  },[userPermission])

  const getMilestoneList =async(filter)=>{
    setloading(true)
    const { data } = await client.query({
      query:OKR_CHILD_LIST_QUERY,
      fetchPolicy: 'network-only',
      variables: {okr_Parent:MilestoneDetail?.id,createdBy:me?.employee?.id,...filter,tz:moment.tz.guess()} 
    });

    if(data){
        setallsubMilestone(data?.contributors)
        dataRef.current =data?.contributors
        await client.subscribe( {
          query: OKR_CHILD_SUBSCRIPTION,
          variables: {okr_Parent:MilestoneDetail?.id,createdBy:me?.employee?.id,...filter}, 
          fetchPolicy: 'network-only'
        } ).subscribe( {
          next( result ) {
            let contributorsCacheData = dataRef.current
            if(!result?.data?.contributorSubscription?.contributor?.okrType && result?.data?.contributorSubscription?.contributor?.role ==="OWNER" && result?.data?.contributorSubscription?.contributor?.okr?.parent?.id===MilestoneDetail?.id){
               switch ( result.data.contributorSubscription.mutation ) {
              case 'CREATE':
                const create = contributorsCacheData?.edges?.filter(item =>
                  item.id === result.data?.contributorSubscription?.contributor?.id
                      ? false
                      : true).concat([{node:result?.data?.contributorSubscription?.contributor}])
                if ( m.current ) {
                 
                  if(create){
                    setallsubMilestone({edges:create})
                    dataRef.current =  {edges:create}
                  }
                  
                }
                break
              case 'UPDATE':
                if ( m.current ) {
                  const Update =contributorsCacheData?.edges?.map( item =>
                      item?.node?.id === result?.data?.contributorSubscription.contributor?.id
                        ? result.data.contributorSubscription.contributor
                        : item
                    ) 
                    if(Update){
                        setallsubMilestone({edges:Update})
                      dataRef.current = {edges:Update}
                    }
                    
                }
                break
                case 'DELETE':
                  if ( m.current ) {
                    const deleted=contributorsCacheData?.edges?.filter( item =>
                        item?.node?.id === result?.data?.contributorSubscription.contributor?.id
                          ? false
                          : true
                      ) 
          
                      if(deleted){
                        setallsubMilestone({edges:deleted})
                        dataRef.current = {edges:deleted}
                      }
                     
                  }
                  break
                default:
                  break
            }
          }
          }})
    }
  
}

React.useEffect(()=>{
  if(me && MilestoneDetail){
    getMilestoneList()
  }
// eslint-disable-next-line react-hooks/exhaustive-deps
},[me,MilestoneDetail])
  return (
    <>
    <SubMileStoneTableView  allsubMilestone={allsubMilestone} permission={permission} loading={loading} setloading={(e)=>setloading(e)} {...props} />
    </>
  );
};

export default  compose(withApollo,withCreateOKR,withCreateContributor)(SubMileStoneTableContainer);
